

import {Component, Prop, Ref, Vue, Watch} from "vue-property-decorator";
import {AlacakliEntity} from "@/entity/AlacakliEntity";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import NotList from "@/components/lists/NotList.vue";
import {NotEntity} from "@/entity/NotEntity";
import {NotTuru} from "@/enum/NotTuru";
import {VekaletEntity} from "@/entity/VekaletEntity";
import {ProgramPaths} from "@/enum/ProgramPaths";
import {TakipDurumu} from "@/enum/TakipDurumu";
import {TakipEntity} from "@/entity/TakipEntity";

@Component({
  components: {NotList, FormDialog, DeleteDialog}
})

export default class AlacakliCardInfo extends Vue {
  @Prop() alacakli!: AlacakliEntity;
  @Prop() takip !: TakipEntity;
  @Ref('notList') readonly notList!: NotList;
  @Prop() takipId !: number;

  alacakliNotlar:Array<NotEntity> = []
  vekalet !: VekaletEntity;
  notTuru = NotTuru
  TakipDurumu = TakipDurumu;
  headers = [
    {text: "Sabit Telefon", value: "deger"},
    {text: "Mobil Telefon", value: "deger"}
  ];

  get takipBilgileriTakipDurumu() {
    // Önce prop'u kontrol et
    if (this.takip && this.takip.takip_durumu) {
      return this.takip.takip_durumu;
    }

    // Sonra store'dan al
    const route = this.$route.path;
    if (route.includes('/icrapro/takip/') && !route.includes('/takip-ekle/')) {
      return this.$store.state.takipDetay?.takip?.takip_bilgileri?.takip_durumu;
    }
    return this.$store.state.takipEkle?.item?.takip_bilgileri?.takip_durumu;
  }

  clickNotlar(){
    if(this.takipBilgileriTakipDurumu !== this.TakipDurumu.acilmamis){
      this.$http.get('/api/v1/alacakli/' + this.alacakli.id + '/notlar').then((response)=>{
        this.alacakliNotlar = response.data.notListesi;
      })
    }

  }

  detay(id: number) {
      this.$router.push(ProgramPaths.ofispro + "/muvekkil/" + id);
  }

  load() {
    this.$emit('load')
    this.clickNotlar()
  }
}
